export default __webpack_public_path__ + "static/media/td.180f416f.svg";